import { WindTurbineStatusSVG } from "./WindTurbineStatusSVG";
export default WindTurbineStatusSVG;
